import pageScrollUtility from '@sparta.sales.utilities/page-scroll-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import sbCreditCardUtility from '@sparta.sb-credit-cards.utilities/sb-credit-card-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { applyNow } from '@sparta.sb-credit-cards.helpers/sb-credit-cards/dist/es6.js';
import '@sparta.sales.utilities/magellan-utility/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = (lookupProperty(helpers,"is")||(depth0 && lookupProperty(depth0,"is"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cardId") : depth0),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"cardId") : stack1),{"name":"is","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":21},"end":{"line":54,"column":11}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n      <div data-magellan-expedition=\"fixed\" data-options=\"destination_threshold:10;threshold:-100;\">\r\n        <div class=\"sticky-wrapper contain-to-grid sticky\">\r\n          <div class=\"row\">\r\n            <div class=\"column small-12\">\r\n              <nav class=\"top-bar clearfix\">\r\n                <ul class=\"left clearfix product-sticky-links hide-for-small-only\" data-magellan-expedition>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"links") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":18},"end":{"line":14,"column":27}}})) != null ? stack1 : "")
    + "                </ul>\r\n\r\n                <div class=\"right-side-container\">\r\n                  <div class=\"apply-now-section\"></div>\r\n\r\n                  <!-- not-ready-to-apply-now dropdown -->\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"options") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":18},"end":{"line":47,"column":25}}})) != null ? stack1 : "")
    + "                </div>\r\n              </nav>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <li class=\"action-link\" data-magellan-arrival=\"#"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" tabindex=\"0\">\r\n                      <a tabindex=\"-1\" class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\" href=\"#"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\"\r\n                        id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"coremetrics") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "</a>\r\n                    </li>\r\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"options-container\">\r\n                      <div class=\"options\">\r\n                        <a id=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"options") : stack1)) != null ? lookupProperty(stack1,"notReadyToOpenButton") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\"javascript:void(0);\" role=\"button\"\r\n                          class=\"button spa-btn spa-btn--reverse spa-btn--small\">\r\n                          <span class=\"notready-medium-up-link\">\r\n                            "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"options") : stack1)) != null ? lookupProperty(stack1,"notReadyToOpenButton") : stack1)) != null ? lookupProperty(stack1,"contentMediumUp") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                          </span>\r\n                          <span class=\"ada-hidden\" id=\"not-readytoopenlayerhelper-text\"></span>\r\n                          <span class=\"spa-accordion-arrow spa-arrow-btn spa-arrow-btn--learn-more\"></span>\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"options-dropdown-menu\">\r\n                        <ul class=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"contact") : depths[1])) != null ? lookupProperty(stack1,"options") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":26},"end":{"line":43,"column":35}}})) != null ? stack1 : "")
    + "                        </ul>\r\n                      </div>\r\n                    </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <li class=\"show-for-small-only "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"className") : depth0), depth0))
    + "\">\r\n                              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"link") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                            </li>\r\n                            <li class=\"show-for-medium-up "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"classNameMediumUp") : depth0), depth0))
    + "\">\r\n                              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"link") : depth0)) != null ? lookupProperty(stack1,"contentMediumUp") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                            </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-sticky\" data-sticky-level=\"2\" id=\"productStickyNavbarSbccModule\">\r\n  "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":54,"column":21}}})) != null ? stack1 : "")
    + "\r\n</div>\r\n<div class=\"data1-jcr\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":56,"column":33},"end":{"line":56,"column":47}}}))
    + "\"></div>\r\n<div class=\"catalogs-jcr\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":57,"column":36},"end":{"line":57,"column":53}}}))
    + "\"></div>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ul class=\"hide-for-small-only\">\r\n  <li class=\"hide-for-small-only\">\r\n    "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"applyNow") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"campaignString") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),(depth0 != null ? lookupProperty(depth0,"catalog") : depth0),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":120}}}))
    + "\r\n  </li>\r\n</ul>\r\n\r\n<div class=\"small-12 sticky-small show-for-small-only\">\r\n  "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"applyNow") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"campaignString") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),(depth0 != null ? lookupProperty(depth0,"catalog") : depth0),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":8,"column":118}}}))
    + "\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/product-sticky-navbar-sbcc-module",
  "version": "5.0.0",
  "id": "productStickyNavbarSbccModule",
  "containerID": "sbCreditCardsProductStickyNavbarSbccModule",
  "moduleName": "sb-credit-cards-product-sticky-navbar-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-sticky-navbar-sbcc-module",
  "data": {
    "init": "ProductStickyNavbarSbccModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "C",
    "description": "Consumer or Small Business Request Type"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        is,
        json,
        applyNow
      },
      "partials": {
        "apply-now-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "apply-now-partial": renderTemplate
  },
  "helpers": {
    is,
    json,
    applyNow
  },
  "dependencies": {
    "@sparta.sales.utilities/page-scroll-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0",
    "@sparta.sb-credit-cards.helpers/sb-credit-cards": "^2.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.sales.utilities/magellan-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The ProductStickyNavbarSbccModule Sparta Module.
 * sparta generate module
 * @export
 * @class
 */
class ProductStickyNavbarSbccModule extends Module {
  /**
   * Creates an instance of ProductStickyNavbarSbccModule.
   * @param {Object} options // Module options
   * @param {Object} context // Module context
   * @memberof ProductStickyNavbarSbccModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    try {
      this.content = JSON.parse(target.querySelector('.data1-jcr').dataset.jcr);
      this.catalogs = JSON.parse(target.querySelector('.catalogs-jcr').dataset.jcr);
      this.MODULE_OFFSET = target ? target.offsetHeight : 0; // height of the module itself
      this.TITLE_OFFSET = document.querySelector('.spa-page-title').classList.contains('spa-sticky') ? document.getElementById('titleModule').offsetHeight : 0;
      this.TOTAL_OFFSET = this.MODULE_OFFSET + this.TITLE_OFFSET;
      // Find the card featured on the page
      this.catalogPropsForCard = '';
      Object.keys(this.catalogs).forEach(index => {
        if (this.catalogs[index].sourceCode === spaParams.pageParams.ddo.product[0].productInfo.sourceCode) {
          // eslint-disable-line
          this.catalogPropsForCard = this.catalogs[index];
        }
      });
      this.cardId = this.catalogPropsForCard.cardId;
      target.dataset.magellanDestination = target.dataset.init;
    } catch (exception) {
      console.error(exception);
    }
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    const {
      target
    } = this.settings;
    const $optionsContainer = $(target).find('.options-container');
    const $options = $optionsContainer.find('.options');
    const $dropDownMenu = $optionsContainer.find('.options-dropdown-menu');
    const $accordionArrow = $options.find('.spa-accordion-arrow');
    const $hiddenText = $options.find('#not-readytoopenlayerhelper-text');
    let dropdownOpen = false;
    sbCreditCardUtility.productPropertiesMap(this.params.requestParams, [`${this.catalogPropsForCard.campaignId}~${this.catalogPropsForCard.pocode}`], ['BYAPAGE_ENABLE', 'APPLY_NOW_BUTTON', 'MARKETING_PRODUCT_NAME_LONG', 'ID']).then(resp => {
      const campaignData = resp[Object.keys(resp)[0]];
      campaignData.campaignString = `${this.catalogPropsForCard.campaignId}~${this.catalogPropsForCard.pocode}~en_US`;
      const linkContent = sbCreditCardUtility.generateLinkContent(this.content, campaignData);
      const catalog = sbCreditCardUtility.generateCardCatalog(this.catalogPropsForCard.campaignId, Object.values(this.catalogs), this.params);
      const templatePartial = _moduleConfig.partials['apply-now-partial']({
        catalog,
        content: linkContent,
        campaign: campaignData,
        site: spaParams.siteParams,
        sparta,
        params: this.params
      });
      target.querySelector('.apply-now-section').innerHTML = templatePartial;
    });

    // Listener to capture click events on sticky-navbar links
    target.addEventListener('click', event => {
      const parentNavigationLink = event.target.parentElement.classList.contains('action-link');
      if (parentNavigationLink && event.target.hash) {
        event.preventDefault();
        const anchorId = event.target.hash.substring(1); // pageScrollUtility expects ID without `#`
        if (anchorId) pageScrollUtility.scrollToID(anchorId, this.TOTAL_OFFSET);
      }
    });

    // Listener to capture Space or Enter keydown events on sticky-navbar links
    target.addEventListener('keydown', event => {
      const spaceOrEnterKeyDown = event.key === ' ' || event.key === 'Enter';
      const isNavigationLink = event.target.classList.contains('action-link');
      const childAnchor = event.target.getElementsByTagName('a')[0];
      if (spaceOrEnterKeyDown && isNavigationLink && childAnchor) {
        event.preventDefault();
        const anchorId = childAnchor.hash.substring(1); // pageScrollUtility expects ID without `#`
        if (anchorId) pageScrollUtility.scrollToID(anchorId, this.TOTAL_OFFSET);
      }
    });
    $optionsContainer.show(1, () => {
      $optionsContainer.addClass('show-menu');
      $options.find('a').attr('tabindex', 0).removeAttr('aria-hidden');
    });

    /**
     * Toggles the state of the dropdown menu.
     * If opened, close. If closed, open.
     * @returns {void}
     */
    function toggleDropDownMenu() {
      const hiddenHelperText = $dropDownMenu.hasClass('expanded') ? ', closed' : ', open';
      $hiddenText.html(hiddenHelperText);
      $dropDownMenu.slideToggle().toggleClass('expanded');
      $accordionArrow.toggleClass('active');
      dropdownOpen = !dropdownOpen;
    }
    $('#not-ready-to-open-now-small-bar-link').on('click', event => {
      event.preventDefault();
      toggleDropDownMenu();
    });
    spartaEventsUtility.sub('UNSTICK.spartaStickyUtility', event => {
      // close the 'open now' dropdown if this module unsticks and the dropdown is open
      if (event && event.data && event.data.id === target.id && dropdownOpen) {
        toggleDropDownMenu();
      }
    });
  }
}
registerModuleClass({
  moduleClass: ProductStickyNavbarSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductStickyNavbarSbccModule as default, moduleConfig };
